<template>
  <div class="loading-container" :style="styleVars || undefined">
    <div class="loading-animation">
      <div class="lds-facebook">
        <div />
        <div />
        <div />
      </div>
    </div>
  </div>
</template>

<script setup>
  import { computed } from 'vue';
  import { useRoute } from 'vue-router';
  import { informacionHabitacion } from '@/store_pinia/informacionHabitacion';
  import { viajesGrupos } from '@/store_pinia/viajesGrupo';
  import { landingStyleVars, isViajeExperienciaStyleRoute } from '@/helpers/landingStyleUtils';

  const route = useRoute();
  const storeHabitacion = informacionHabitacion();
  const viajesGruposStore = viajesGrupos();

  const styleVars = computed(() => {
    if (!isViajeExperienciaStyleRoute(route.name)) return null;

    const style = storeHabitacion.getViaje?.style || viajesGruposStore.getViajeSeleccionado?.style;
    return style ? landingStyleVars(style) : null;
  });
</script>

<style lang="css" scoped>
  .loading-container {
    background-color: rgba(var(--bs-white-rgb), 0.5);
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 19000;
    overflow: hidden;
  }

  .loading-animation {
    padding: 2rem;
  }

  .lds-facebook {
    display: inline-block;
    position: relative;
    width: 80px;
    height: 80px;
  }
  .lds-facebook div {
    display: inline-block;
    position: absolute;
    left: 8px;
    width: 16px;
    background-color: var(--landing-detail-color, var(--bs-primary));
    animation: lds-facebook 1.2s cubic-bezier(0, 0.5, 0.5, 1) infinite;
  }
  .lds-facebook div:nth-child(1) {
    left: 8px;
    animation-delay: -0.24s;
  }
  .lds-facebook div:nth-child(2) {
    left: 32px;
    animation-delay: -0.12s;
  }
  .lds-facebook div:nth-child(3) {
    left: 56px;
    animation-delay: 0;
  }
  @keyframes lds-facebook {
    0% {
      top: 8px;
      height: 64px;
    }
    50%,
    100% {
      top: 24px;
      height: 32px;
    }
  }
</style>
